import React, { useContext, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet } from 'react-router-dom';
function DashboardMain(props) {


    return (
        <>
            <Header gloablfilter={props.gloablfilter} />
            <Sidebar />
            {props.children}
        </>
    );



}

export default DashboardMain;